import { Contrato } from '../models/contrato.interface';

export interface ContratoState {
  contratos: Contrato[];
  selectedContrato: Contrato | null;
  loading: boolean;
  error: string | null;
  creating: boolean;
  updating: boolean;
  deleting: boolean;
  searchResults: Contrato[];
  searchQuery: string;
}

export const initialContratoState: ContratoState = {
  contratos: [],
  selectedContrato: null,
  loading: false,
  error: null,
  creating: false,
  updating: false,
  deleting: false,
  searchResults: [],
  searchQuery: ''
};
